module.exports = __webpack_public_path__ + "img/fz-2.923e0410.png";